import React, { useEffect, useRef, useState } from "react";

const LogoList = ({ items, duplicate = false }) => (
  <ul
    aria-hidden={duplicate ? "true" : undefined}
    className="logo-ticker__list"
  >
    {items.map((item) => (
      <li className="logo-ticker__item" key={`${duplicate ? "copy-" : ""}${item.name}`}>
        <img
          alt={duplicate ? "" : item.name}
          decoding="async"
          height={item.height}
          loading="lazy"
          sizes={item.sizes}
          src={item.src}
          srcSet={item.srcSet}
          width={item.width}
        />
      </li>
    ))}
  </ul>
);

const LogoTicker = ({
  items = [],
  label = "Organizations I’ve worked with",
  showLabel = true,
  showControl = true,
}) => {
  const viewportRef = useRef(null);
  const [manuallyPaused, setManuallyPaused] = useState(false);
  const [interactionPaused, setInteractionPaused] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const updatePreference = () => setPrefersReducedMotion(mediaQuery.matches);

    updatePreference();
    mediaQuery.addEventListener("change", updatePreference);
    return () => mediaQuery.removeEventListener("change", updatePreference);
  }, []);

  if (!Array.isArray(items) || !items.length) return null;

  const paused = manuallyPaused || interactionPaused || prefersReducedMotion;

  return (
    <section className="logo-ticker" aria-label={label}>
      <div className="container logo-ticker__container">
        {(showLabel || (showControl && !prefersReducedMotion)) && (
          <div className="logo-ticker__header">
            {showLabel && <p className="logo-ticker__label">{label}</p>}
            {showControl && !prefersReducedMotion && (
              <button
                aria-label={manuallyPaused ? "Play ticker" : "Pause ticker"}
                aria-pressed={manuallyPaused}
                className="logo-ticker__control"
                onClick={() => setManuallyPaused((current) => !current)}
                title={manuallyPaused ? "Play ticker" : "Pause ticker"}
                type="button"
              >
                <span aria-hidden="true">{manuallyPaused ? "▶" : "Ⅱ"}</span>
              </button>
            )}
          </div>
        )}

        <div
          className="logo-ticker__viewport"
          onBlurCapture={(event) => {
            if (!event.currentTarget.contains(event.relatedTarget)) {
              setInteractionPaused(false);
            }
          }}
          onFocusCapture={() => setInteractionPaused(true)}
          onMouseEnter={() => setInteractionPaused(true)}
          onMouseLeave={() => setInteractionPaused(false)}
          ref={viewportRef}
        >
          <div
            className={`logo-ticker__track${paused ? " logo-ticker__track--paused" : ""}`}
          >
            <LogoList items={items} />
            <LogoList duplicate items={items} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoTicker;
